import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import {
  IconRegistryConfig,
  IconRegistryService,
} from './icon-registry.service';

@NgModule({
  imports: [CommonModule, MatIconModule, HttpClientModule],
  providers: [IconRegistryService],
})
export class IconModule {
  constructor(
    private iconRegistryService: IconRegistryService,
    @Optional() @SkipSelf() parentModule?: IconModule
  ) {
    if (parentModule) {
      throw new Error('IconModule is already loaded.');
    }
    this.iconRegistryService.registerIcons();
  }

  static forRoot(config: IconRegistryConfig): ModuleWithProviders<IconModule> {
    return {
      ngModule: IconModule,
      providers: [{ provide: IconRegistryConfig, useValue: config }],
    };
  }
}
